import NumberFormat from 'react-number-format';
import { useListVehiclesHighestBid } from '../hooks';

export const ProxyBid = ({ vehicle }) => {
  const { proxy } = useListVehiclesHighestBid(vehicle);
  return <NumberFormat displayType="text" prefix="$" value={proxy?.amount || 0} thousandSeparator />;
};
